import { Collection } from 'es6/components/collection'
import { Settlement } from 'es6/models/settlement'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Коллекция для поселений
 */
@Defaults({
  model: Settlement,
  urlRoot: `${entryScriptName}/api/v3/settlement`,
})
export class Settlements extends Collection {
  /** @inheritDoc */
  run (data, options) {
    if (options && options.user) {
      this.user = options.user
    }
    this.expand = 'expand=has_active_jp_purchase'
  }
}
